import React from "react";
import { NavLink } from "react-router-dom";
const links = [
  { path: "/dashboard/home", label: "Home" },
  { path: "/dashboard/wishlist", label: "Wishlist" },
  { path: "/dashboard/order", label: "Orders" },
  { path: "/dashboard/settings", label: "Settings" },
];
const DashboardSidebar = () => {
  return (
    <div className="dashboard-sidebar">
      <nav className="nav">
        {links.map((link, index) => (
          <NavLink
            key={index}
            to={link.path}
            className={({ isActive }) => (isActive ? "nav-link active" : "nav-link")}
          >
            {link.icon && <span className="icon">{link.icon}</span>}
            {link.label}
          </NavLink>
        ))}
      </nav>
      <div className="footer">
        <button className="logout-btn">Logout</button>
      </div>
    </div>
  );
};

export default DashboardSidebar;
